import i18next from 'i18next';
import permissions from '@shared/config/permissions';
import { INFO_PANE_PAGES } from 'redux_store';
import { PATIENT_ENGAGEMENT_STATUS_OPTIONS } from './patientEnums';
// eslint-disable-next-line no-restricted-imports
import { CUSTOM_TAGS_OPTIONS, PATIENT_CUSTOM_TAGS_OPTIONS } from '_legacy/components/Shared/CustomTags';
// eslint-disable-next-line no-restricted-imports
import FILTER_TYPES from '@shared/ui/Table/Filters/constants';

/**
 * Column definitions for the Patients list table. Lifted whole from
 * `_legacy/components/Patients/constants.js#PATIENTS_COLUMNS` so the
 * legacy file can be deleted in a follow-up task. The legacy
 * `CustomTags` options + `Filters/constants` modules are still
 * consumed from `_legacy/...` until those migrate to FSD; the two
 * targeted eslint-disable lines mirror the same shim used by the
 * `@entities/user` columns module.
 */
export const PATIENTS_COLUMNS = [
  {
    size: 270,
    header: i18next.t('tables:accountCustomTags'),
    accessorKey: 'accountCustomTags',
    filter: { filterType: FILTER_TYPES.SELECT, options: CUSTOM_TAGS_OPTIONS },
    cell: { withBubbles: true },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 220,
    header: i18next.t('tables:account'),
    accessorKey: 'accountBusinessName',
    filter: { filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT },
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: { filterType: FILTER_TYPES.SELECT, options: PATIENT_CUSTOM_TAGS_OPTIONS },
    cell: { withBubbles: true },
    permission: permissions.ACCOUNTS_GET,
  },
  {
    size: 200,
    header: i18next.t('tables:customId'),
    accessorKey: 'accountCustomIdentifier',
    filter: {},
    permission: permissions.ACCOUNTS_GET,
    enableHiding: false,
    isDefaultCell: true,
  },
  {
    size: 200,
    header: i18next.t('tables:mrnNumber'),
    accessorKey: 'mrnNumber',
    filter: {},
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  {
    size: 200,
    header: i18next.t('tables:firstName'),
    accessorKey: 'firstName',
    filter: {},
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  {
    size: 200,
    header: i18next.t('tables:lastName'),
    accessorKey: 'lastName',
    filter: {},
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  {
    size: 200,
    header: i18next.t('tables:dateOfBirth'),
    accessorKey: 'dateOfBirth',
    filter: { filterType: FILTER_TYPES.DATE },
    cell: { infoPanePage: INFO_PANE_PAGES.patient_page },
  },
  // Patient Engagement master flag (port of dev PR 2176). The
  // `engagementStatus` accessor key contains "status", so TableCell
  // auto-renders a badge coloured via `getStatusBadge` (enabled ->
  // normal, disabled -> critical). Older APIs omit the field — the
  // cell degrades to an empty badge like every other status column.
  {
    size: 200,
    header: i18next.t('tables:patientEngagement'),
    accessorKey: 'engagementStatus',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: PATIENT_ENGAGEMENT_STATUS_OPTIONS,
    },
  },
];
